// extracted by mini-css-extract-plugin
export default {"versionText":"Version_versionText__DDTI8"};